import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

const Modal = (props) => {
    const {
        details: {
            name,
            className,
            linkClassName,
            modalName,
            text
        },
        index,
        replacements,
        showModal
    } = props;

    const handleOpeningModal = (event, modalName) => {
        event.preventDefault();
        showModal({
            modalType: modalName
        });
    };

    return (
        <Fragment>
            <li className={className} id={`${name}_${index}`}>
                <a href="#" className={linkClassName} id={name} data-automation-id={name} onClick={(e) => handleOpeningModal(e, modalName)}>
                    <FormattedMessage
                        id = {text}
                        values = {replacements}
                    />
                </a>
            </li>
        </Fragment>
    );

};

export default Modal;